import { Component } from '@angular/core';
import { soundpostAgreementStatusEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Agreement Status') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostagreementstatus-form',
    templateUrl: './soundpostagreementstatus.form.component.html'
})
export class soundpostAgreementStatusFormComponent extends BaseFormComponent {
    public record!: soundpostAgreementStatusEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'agreements', sectionName: 'Agreements', isExpanded: false }
        ]);
    }
}

